var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.98 32.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#39637b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "szare_pola_kontaktu",
    "data-name": "szare pola kontaktu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_17",
    "data-name": "Shape 17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,4.15a4.11,4.11,0,0,0-1.09-2.77l0,0s0,0,0,0a4.19,4.19,0,0,0-3-1.31H4.2a4.19,4.19,0,0,0-3,1.31s0,0,0,0l0,0A4.11,4.11,0,0,0,0,4.15V28.61a4.1,4.1,0,0,0,1.14,2.83l0,0s0,0,0,0a4.2,4.2,0,0,0,3,1.27H45.78a4.2,4.2,0,0,0,3-1.27h0l0,0A4.1,4.1,0,0,0,50,28.61V4.15ZM33.62,15.09,48,3.15a2.36,2.36,0,0,1,.22,1V28.61a2.51,2.51,0,0,1-.18.92ZM45.78,1.71a2.49,2.49,0,0,1,1,.22L25,20,3.18,1.93a2.53,2.53,0,0,1,1-.22ZM1.92,29.53a2.33,2.33,0,0,1-.19-.92V4.15a2.37,2.37,0,0,1,.23-1l14.4,11.94ZM4.2,31.05a2.46,2.46,0,0,1-1.11-.27l14.6-14.59,6.75,5.59A.82.82,0,0,0,25,22a.85.85,0,0,0,.56-.21l6.74-5.59,14.6,14.59a2.46,2.46,0,0,1-1.11.27Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIco);
export default __webpack_public_path__ + "static/media/envelope-ico.b288bf2662271669d48339754a502334.svg";
export { ForwardRef as ReactComponent };